import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { PRODUCTS, openWhatsApp } from "@/data/content";

const Products = () => {
  return (
    <section id="produtos" data-testid="products-section" className="bg-slate-50 py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <p className="text-[#1d3fd9] font-bold tracking-widest text-sm mb-4">CATÁLOGO</p>
          <h2 className="text-4xl lg:text-5xl font-extrabold text-[#0f1733] tracking-tight">Nossos Produtos</h2>
          <p className="text-slate-500 text-lg mt-5">
            Somos representantes autorizados da Ultragaz, fornecendo GLP e água mineral com qualidade e segurança.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {PRODUCTS.map((p, i) => (
            <motion.div
              key={p.id}
              data-testid={`product-card-${p.id}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className="bg-white rounded-3xl p-5 shadow-sm hover:shadow-2xl transition-all duration-300 hover:-translate-y-1 flex flex-col"
            >
              <div className="relative">
                {p.badge && (
                  <span className="absolute top-2 left-2 z-10 bg-[#dff4b0] text-[#3f5d00] text-xs font-bold px-3 py-1.5 rounded-full">
                    {p.badge}
                  </span>
                )}
                <div className="bg-slate-50 rounded-2xl h-60 flex items-center justify-center p-4">
                  <img src={p.image} alt={p.name} className="h-full object-contain mix-blend-multiply" />
                </div>
              </div>

              <h3 className="text-xl font-extrabold text-[#0f1733] mt-6">{p.name}</h3>
              <p className="text-slate-500 mt-3 leading-relaxed flex-1">{p.description}</p>

              <div className="flex flex-wrap gap-2 mt-5">
                {p.tags.map((t) => (
                  <span key={t} className="bg-slate-100 text-slate-600 text-xs font-semibold px-3 py-1.5 rounded-lg">
                    {t}
                  </span>
                ))}
              </div>

              <button
                data-testid={`product-order-${p.id}`}
                onClick={() => openWhatsApp(`Olá! Tenho interesse em: ${p.name}. Pode me ajudar?`)}
                className="mt-6 w-full flex items-center justify-center gap-2 bg-[#1d3fd9] hover:bg-[#1631b3] text-white font-bold py-3.5 rounded-2xl transition-all"
              >
                <MessageCircle className="w-5 h-5" /> Pedir Agora
              </button>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Products;
